// 印尼语

export default {
  t1: 'Selesai',
  t5: 'Bayar',
  t6: 'Ikat dan otorisasi',
}
